import { connect } from 'react-redux';
import Payroll from '../../../views/Personnel/Payroll/Payroll.payroll.view';

export default Payroll;
